export default "__VITE_ASSET__I8j9jp_n__"